import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetWarrantyClaimsItemDropdownQuery } from '../../api';
import { useLanguage } from '../../contexts/LanguageContext';

const ItemCodeDropdownwithId = ({ value, onChange, className, disabled, warrantyClaimId }) => {
    const { getCurrentLanguageId, th } = useLanguage();
    const [selectedItem, setSelectedItem] = useState(null);
    const [searchText, setSearchText] = useState('');

    const languageId = getCurrentLanguageId();
    
    const { data: itemList = [], isLoading: isLoadingItems, refetch } = useGetWarrantyClaimsItemDropdownQuery({
        RowCount: 100,
        SearchText: searchText,
        LanguageId: languageId,
        WarrantyClaimId: warrantyClaimId
    });

    const itemOptions = useMemo(() => {
        return itemList.map((item) => ({
            id: item.id,
            itemCode: item.itemCode,
            title: item.title,
            displayValue: `${item.itemCode} - ${item.title}`,
            itemPrice: item.itemPrice,
            itemPriceCurr: item.itemCurrency
        }));
    }, [itemList]);

    const handleSelectionChange = (e) => {
        setSelectedItem(e.value);
        onChange(e.value);
    };

    const handleFilterChange = (e) => {
        setSearchText(e.filter);
    };

    const handleDropdownShow = () => {
        // Her dropdown açıldığında API'ye istek at
        refetch();
    };

    useEffect(() => {
        if (selectedItem) {
            // ID-based karşılaştırma: value number olarak gelecek
            if (typeof value === 'number' && selectedItem.id?.toString() === value.toString()) {
                return;
            }
            // Object value için karşılaştırma
            else if (typeof value === 'object' && value !== null) {
                if (selectedItem.id === value.id) {
                    return;
                }
            }
        }

        if (itemOptions.length > 0 && value !== null && value !== undefined) {
            let found;

            if (typeof value === 'object' && value !== null) {
                // Object value için ID-based arama
                found = itemOptions.find((option) => option.id === value.id);
            } else if (typeof value === 'string' || typeof value === 'number') {
                // String veya number value için ID-based arama
                found = itemOptions.find((option) => option.id?.toString() === value.toString());
            }

            if (found) {
                setSelectedItem(found);
            } else if (typeof value === 'number') {
                // String veya number value için yeni option oluştur (ID-based)
                const newOption = {
                    id: typeof value === 'number' ? value : parseInt(value) || 0,
                    itemCode: value.toString(),
                    title: value.toString(),
                    displayValue: `${value} - ${value}`
                };
                setSelectedItem(newOption);
            } else if (typeof value === 'object' && value !== null) {
                // Object value için yeni option oluştur
                const itemCode = value.itemCode || '';
                const title = value.title || value.partName || itemCode;
                const newOption = {
                    id: value.id || 0,
                    itemCode: itemCode,
                    title: title,
                    displayValue: `${itemCode} - ${title}`
                };
                setSelectedItem(newOption);
            }
        }
    }, [value, itemOptions]);

    return (
        <Dropdown
            disabled={disabled}
            value={selectedItem}
            options={itemOptions}
            onChange={handleSelectionChange}
            onFilter={handleFilterChange}
            onShow={handleDropdownShow}
            optionLabel="displayValue"
            filter
            showClear
            filterBy="itemCode,title"
            className={className}
            placeholder={th('common.itemCodeSelectPlaceholder')}
            loading={isLoadingItems}
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.itemCode}</span> - {option.title}
                </div>
            )}
        />
    );
};

export default ItemCodeDropdownwithId;
